// ContactusBannerHeader.jsx
import React from "react";
import styled from "styled-components";
import contactusVideo from "../../../assets/images/contactUs/contactus.mp4"; // ✅ use contact video

const HeaderContainer = styled.header`
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  font-family: "Poppins", system-ui;

  @media (max-width: 768px) {
    min-height: 80vh;
  }

  @media (max-width: 576px) {
    min-height: 70vh;
  }
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
  z-index: -1;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  /* slightly richer gradient overlay */
  background: linear-gradient(
      120deg,
      rgba(0, 0, 0, 0.7),
      rgba(6, 51, 75, 0.6),
      rgba(0, 0, 0, 0.85)
    );
  z-index: 1;
`;

const HeaderText = styled.h1`
  font-size: 4rem;
  z-index: 2;
  font-family: "Poppins", system-ui;
  font-weight: 700;
  font-style: normal;

  span {
    color: #07b6f2;
  }

  @media (max-width: 768px) {
    font-size: 3rem;
  }

  @media (max-width: 576px) {
    font-size: 2rem;
  }
`;

const ContactusBannerHeader = () => {
  return (
    <HeaderContainer>
      <BackgroundVideo autoPlay loop muted playsInline>
        <source src={contactusVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </BackgroundVideo>
      <Overlay />
      <HeaderText>
        Contact <span>Us</span>
      </HeaderText>
    </HeaderContainer>
  );
};

export default ContactusBannerHeader;
